/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('shared').filter('formatPrice', ['calculationService', calculationService =>
  function(price, decimals = 2) {
    return calculationService.round(price, decimals);
  }
]);
